<div class="" style="padding-top: 1.75rem" data-test-id="wrap-authenticator">
  <label class="form-label">
    {{ 'BIND_AUTHENTICATOR_FIELD_HINT' | translate }}
  </label>
</div>
<button
  *ngIf="!hasBoundAuthenticator"
  class="btn btn-primary authenticator-btn"
  type="button"
  [attr.data-test-id]="'bind-authenticator-btn'"
  (click)="bindAuthenticator()"
>
  {{ 'BIND_AUTHENTICATOR_BTN' | translate }}
</button>
<button
  *ngIf="hasBoundAuthenticator"
  class="btn btn-primary authenticator-btn"
  type="button"
  [attr.data-test-id]="'unbind-authenticator-btn'"
  (click)="unbindAuthenticator()"
>
  {{ 'UNBIND_AUTHENTICATOR_BTN' | translate }}
</button>
